
export default class

  # fileName

  constructor: (@fileName) ->

  play: (volume) ->
    a 1 <= volume && volume <= 10
    @_play volume

  # с нулевой громкостью оно не прелоадится
  preload: -> @_play 0.001

  _play: (volume) ->
    # @TODO: maybe cache element?
    audio = document.createElement 'audio'
    audio.src    = "/sounds/#{ @fileName }"
    audio.volume = volume / 10
    audio.play()
    @
